import React from 'react';
import OrderList from './OrderList';

class OrderPage extends React.Component {
  render() {
    return (
      <div>
        <OrderList />
      </div>
    );
  }
}

export default OrderPage;



// WEBPACK FOOTER //
// ./src/components/order/OrderPage.js